import { socketEmit } from 'redux-saga-sc'
import camelCase from 'camel-case'

const REQUEST = 'REQUEST'
const SUCCESS = 'SUCCESS'
const FAILURE = 'FAILURE'
const CANCEL = 'CANCEL'
const PROGRESS = 'PROGRESS'
const TYPES = [REQUEST, SUCCESS, FAILURE, CANCEL, PROGRESS]

export const action = (type, payload = {}) => ({ type, ...payload })

export const socketAction = (type, payload = {}) => socketEmit({ type, ...payload })

export const createRequestTypes = (base, moreTypes = []) => TYPES.concat(moreTypes).reduce((types, type) => {
    types[type.toUpperCase()] = `${base}_${type.toUpperCase()}`
    return types
}, {})

export const createRequestActions = (REQUEST_TYPES, moreTypes = []) => TYPES.concat(moreTypes).reduce((actions, type) => {
    actions[camelCase(type)] = (payload) => action(REQUEST_TYPES[type], { payload })
    return actions
}, {})


// WEBPACK FOOTER //
// ./src/client/core/actions.js